module.exports = __webpack_public_path__ + "static/img/zxkf.c9869935.png";